import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import clsx from 'clsx';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import FeedbackIcon from '@mui/icons-material/Feedback';
import StepConnector, {
  stepConnectorClasses,
} from '@mui/material/StepConnector';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 25,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.main,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.success.main,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.text.primary,
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const useColorlibStepIconStyles = makeStyles(theme => ({
  root: {
    zIndex: 1,
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.secondary.main,
  },
  active: {
    color: theme.palette.text.primary,
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    backgroundColor: theme.palette.primary.main,
  },
  completed: {
    color: theme.palette.text.primary,
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    backgroundColor: theme.palette.success.main,
  },
}));

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { icon, active, completed } = props;

  const icons = {
    1: <PersonAddIcon />,
    2: <CheckBoxIcon />,
    3: <LocalShippingIcon />,
    4: <FeedbackIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};
const useStyles = makeStyles(theme => createStyles({
    root: {
      width: '100%',
      borderRadius: 0,
      padding: 2,
    },
    button: {
      marginRight: theme.spacing(1),
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    meta: {
      fontSize: theme.typography.pxToRem(16),
      [theme.breakpoints.down('md')]: {
        fontSize: theme.typography.pxToRem(12),
      },
    },
  }));

export default function IconBasedTimeline(props) {
  const classes = useStyles();
  const { steps, activeStep } = props;
  return (
    <div className={classes.root}>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        className={classes.root}
        connector={<ColorlibConnector />}
      >
        {steps?.map(step => (
          <Step key={step.id}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>
              <p className={classes.meta}>
                {step.date}
                <br />
                {step.text}
                {/* {`${step.text}${
                  step.chatterbox && step.chatterbox.additionalText
                    ? ` & ${step.chatterbox.additionalText}`
                    : ''
                }`} */}
              </p>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
}

IconBasedTimeline.propTypes = {
  size: PropTypes.number,
  steps: PropTypes.array,
  activeStep: PropTypes.number,
};
